(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsPropertiesController', TabObjectsPropertiesController);

    TabObjectsPropertiesController.$inject = ['$state', '$stateParams', 'pagingParams', 'entity', 'properties', '$uibModal', 'paginationConstants', 'editableOptions', 'TabObjectProperties'];

    function TabObjectsPropertiesController($state, $stateParams, pagingParams, entity, properties, $uibModal, paginationConstants, editableOptions, TabObjectProperties) {
        var vm = this;
        var editedProperty = {};
        vm.saveReference = saveReference;
        vm.checkValueBeforeSave = checkValueBeforeSave;
        vm.checkBeforeExit = checkBeforeExit;
        vm.checkNoPendingEdit = checkNoPendingEdit;
        vm.reloadState = reloadState;
        vm.save = save;
        vm.search = "";
        editableOptions.theme = 'bs3';
        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.tabObject = entity;
        vm.properties = properties;
        vm.predicates = pagingParams.predicates;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            return sortFields;
        }

        vm.reloadPage = function () {
            $state.go('tab-objects-properties', {id: vm.tabObject.id, sort: sort(), predicates: vm.predicates});
        }

        function saveReference(data) {
            editedProperty[data.id] = data;
            save();
        }

        function checkValueBeforeSave(data) {
            return data ? true : "Value cannot be empty";
        }

        function checkBeforeExit() {
            if (checkNoPendingEdit()) {
                window.history.back();
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objects-properties-dialog.html'
                }).result.then(function () {
                    window.history.back();
                }, function () {
                    //null
                });
            }
        }

        function reloadState() {
            $state.transitionTo($state.current, $stateParams, {
                reload: true
            });
        }

        function checkNoPendingEdit() {
            return angular.equals({}, editedProperty);
        }

        function save() {
            if (!checkNoPendingEdit()) {
                var sendingProperties = [];
                for (var key in editedProperty) {
                    sendingProperties.push(editedProperty[key]);
                }

                TabObjectProperties.update({
                    properties: sendingProperties,
                    objectUniqueCode: vm.tabObject.objectUniqueCode
                }, onSaveSuccess);
            }
        }

        function onSaveSuccess(result) {
            editedProperty = {};
            //$state.transitionTo($state.current, $stateParams, {
            //    reload: true
            //});
        }

    }
})();
